<div mat-dialog-header>
  <h1 class="w-100">Download Roles/Rights History Report</h1>
</div>
<mat-dialog-content #scroll class="dialog-container">
  <form>
    <mat-form-field class="me-2 startDate">
      <mat-label>Start Date</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        placeholder="Choose a start date"
        [formControl]="startDate"
        [required]="true"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="startPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="me-2 endDate">
      <mat-label>End Date</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        placeholder="Choose an end date"
        [formControl]="endDate"
        [required]="true"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="mt-0 row buttons">
  <button mat-raised-button color="accent" (click)="download()">
    Download
  </button>
  <button mat-raised-button (click)="cancel()"> Cancel </button>
</mat-dialog-actions>
